import React, { CSSProperties } from "react";
import { JokerButton } from "material-ui-jokerpro";
import clsx from "clsx";
import styles from "./FooterCard.module.css";
import Paragraph, { ParagraphSize } from "../Paragraph";
import TitleText, { TitleTextSize } from "../TitleText";
import AssetsPack from "../../util/AssetsPack.js";
import ImageComponent from "../ImageComponent";
import AutoPlayMutedVideo from "../AutoPlayMutedVideo";

export enum AccentColor {
  black = "black", // JokerBlack200
  blue = "blue", // rgba(44, 78, 74, 1)
  green = "green", // rgba(25, 63, 92, 1)
}
interface FooterCardProps {
  title: string;
  subtitle: string;
  buttonText: string;
  cardBackgroundStyle: CSSProperties;
  icon?: string;
  accentColor?: AccentColor;
  isFullWidth?: boolean;
  href?: string;
  onClick?: (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => void;
  isDisable?: boolean;
}

const FooterCard: React.FC<FooterCardProps> = ({
  title,
  subtitle,
  buttonText,
  icon,
  href,
  onClick,
  accentColor = AccentColor.black,
  cardBackgroundStyle,
  isFullWidth,
  isDisable = false,
}) => {
  return (
    <div
      className={clsx(
        { [styles[accentColor]]: accentColor },
        styles["card"],
        isFullWidth && styles["full-width"]
      )}
      style={cardBackgroundStyle}
    >
      {isFullWidth && (
        <AutoPlayMutedVideo
          videoSrc={AssetsPack.videos.FOOTER}
          classNameStyle={styles["card-video-background"]}
        />
      )}

      <div className={clsx(isFullWidth && styles["sub-card"])}>
        <TitleText
          size={isFullWidth ? TitleTextSize.heading3 : TitleTextSize.heading4}
        >
          {title}
        </TitleText>
        <div className={styles["subtitle-container"]}>
          <Paragraph
            size={ParagraphSize.paragraph2}
            classNameStyle={clsx(
              !isFullWidth && styles["description-container"]
            )}
          >
            {subtitle}
          </Paragraph>
        </div>
        <div className={styles["button-container"]}>
          <JokerButton
            text={buttonText}
            icon={AssetsPack.icons.ICON_GO.default}
            href={href}
            onClick={onClick}
            disabled={isDisable}
          />
        </div>
      </div>
      {icon && (
        <div
          className={clsx(
            { [styles[accentColor]]: accentColor },
            styles["icon-container"]
          )}
        >
          <div
            className={clsx(
              { [styles[accentColor]]: accentColor },
              styles["icon-inner-container"]
            )}
          >
            <ImageComponent src={icon} />
          </div>
        </div>
      )}
    </div>
  );
};

export default FooterCard;
